import React from "react";
import Link from "next/link";
import TermsContainer from "./TermsContainer";

export default function ShippingAndReturnsTerms() {
  return (
    <TermsContainer>
      <h2>Shipping, Cancellation and Returns Policy</h2>

      <div className="mt-5">
        <p>Effective Date: March 5, 2022.</p>
      </div>

      <h4>Shipping Guidelines</h4>
      <p>
        We ship to Canada, The United States, The United Kingdom and most other
        countries within the European Union. Shipping fees are calculated based
        on the shipping address you provide to us. If you are subscribed to one
        or more of our rebillable subscription(s), upon renewal, a shipping fee
        is added to the then-current subscription rate plus any applicable
        taxes. This shipping fee is calculated based on the default shipping
        address we have on file for your account, so you must ensure that your
        default shipping address is always up to date.
      </p>

      <p>
        Orders over <strong>$100</strong> are eligible for free shipping unless
        the order also includes a rebillable subscription.
      </p>

      <p>
        Shipping notifications are sent via email. Additionally, you may
        subscribe to SMS shipping updates for your order from the order status
        page. SMS Shipping updates are not instantaneous - there may be
        discrepancies between when you receive an update and when the update
        actually occurred. SMS shipping notifications are provided for
        convenience only. For the latest tracking information, you may track
        your package directly from our website{" "}
        <Link href="/tracking">
          <a className="styled-underlined-link">here</a>
        </Link>{" "}
        or via the carrier's tracking page.
      </p>

      <h4>Subscription Cancellation Policy</h4>
      <p>
        You may cancel your subscription at anytime directly from your account
        by following the steps in{" "}
        <a
          className="styled-underlined-link"
          href="https://help.chicbeautybox.com/portal/en/kb/articles/how-do-i-cancel-my-subscription"
          target="blank"
        >
          this article
        </a>
        . There is no fee associated with cancellation and you will no longer be
        charged once you cancel your subscription. If an active subscriber
        cancels their subscription, they will still receive products through the
        end of the then-current subscription term. Active subscriber's
        subscriptions will not be renewed after the then-current term expires.
        However, you are not and will not be eligible for a prorated refund of
        any portion of the subscription fee paid for the then-current
        subscription period. This means that if an active subscriber cancels
        their subscription after one (1) month but prepaid for twelve (12)
        months, they will not receive any money back, but will keep receiving
        boxes until the end of the subscription term (in this case 12 months).
        Anyone may resubscribe at any time following cancellation. You may also
        choose to pause/suspend your subscription at no cost from your account
        dashboard. If you pause a subscription, you will not be charged on a
        recurring basis until you resume your subscription.
      </p>

      <p>
        By using this Site, you understand and agree that you shall receive no
        refunds and no exchanges for any product(s) once they are purchased,
        unless the product is received damaged or expired. Chic Beauty Box
        provides a selection of products which may vary from box to box sent to
        various Members. Chic Beauty Box cannot accommodate specific requests
        for certain products, as we operate from a limited inventory of products
        depending on availability.
      </p>

      <h4>Refund/Returns Policy</h4>

      <p>
        <strong>
          <u>SUBSCRIPTIONS</u>
        </strong>
      </p>
      <p>
        Subscription boxes may not be returned or exchanged for whatever reason.
        If a product or products arrived to you damaged or expired, we will send
        you a replacement or offer you other forms of compensation which may
        include, without limitation: a replacement, store credit, including the
        product in your next box. However, you must make this information known
        to us in a timely manner to be eligible for compensation in accordance
        with{" "}
        <a
          className="styled-underlined-link"
          href="https://help.chicbeautybox.com/portal/en/kb/articles/what-is-your-replacement-policy"
          target="_blank"
        >
          our Replacement Policy
        </a>
        .
      </p>

      <p>
        <strong>
          <u>STORE PURCHASES / ADD-ONS</u>
        </strong>
      </p>
      <p>
        All purchases are final sale and nonrefundable. We do not currently
        accept returns for products bought through our store. Any product
        returned by a customer will not be eligible for a refund.
      </p>

      <p>
        If you never received your product(s) or you received a product damaged
        you may be eligible for compensation in accordance with{" "}
        <a
          className="styled-underlined-link"
          href="https://help.chicbeautybox.com/portal/en/kb/articles/what-is-your-replacement-policy"
          target="_blank"
        >
          our Replacement Policy
        </a>
        .
      </p>
    </TermsContainer>
  );
}
